module.exports = __webpack_public_path__ + "media/mypage/images/flat/flats-8c26eb0b8b9bc9456714966c739df803.png";